import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Button,
  TableHead,
  TableRow,
  FormControl,
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TextField,
  Dialog,
  DialogContent,
  DialogActions,
  Chip,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import utils from "../../utils/utils";
import ReactSelect from "react-select";
import "./Dashboard.scss";
import api from "../../api";
import Pagination from "@material-ui/lab/Pagination";
import CircularProgress from "@material-ui/core/CircularProgress";
import InfoIcon from "@material-ui/icons/Info";
import {
  Role,
  AgreementStatus,
  IndicatorsType,
  IndicatorDetail,
} from "../../enums/enums";
import Tooltip from "@material-ui/core/Tooltip";
import { useSelector } from "react-redux";

export default function Dashboard({ setDataToast, setIsLoading }) {
  const [indicators, setIndicators] = useState({});
  const [isAdmin, setIsAdmin] = useState(false);
  const [dataTablePopup, setDataTablePopup] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);
  const [filterIndicator, setFilterIndicator] = useState({
    indicatorType: undefined,
    indicatorDetail: undefined,
  });
  const itemsPerPage = 10;
  const [paginationData, setPaginationData] = useState({
    amount: 0,
    currentPage: 1,
  });
  const [companiesList, setCompaniesList] = useState();
  const [companyFilter, setCompanyFilter] = useState();
  const [cards, setCards] = useState(false);

  const { decoded } = useSelector((state) => state.authReducer);

  useEffect(() => {
    let role = decoded.role;
    if (role === Role.AdminComercial) {
      setIsAdmin(true);
    }

    api.getCompanies().then((res) => {
      setCompaniesList(utils.setDataInSearchList(res.data));
    });
  }, []);

  function paginate(page_number) {
    getAgreementByIndicator(
      page_number,
      filterIndicator.indicatorType,
      filterIndicator.indicatorDetail
    );
  }

  function search(e) {
    e.preventDefault();
    let filters = {
      companyId: companyFilter ? companyFilter.key : null,
    };

    let role = decoded.role;
    if (role === Role.AdminComercial) {
      setIsAdmin(true);
      api
        .getAgreementsIndicators(filters.companyId)
        .then((res) => {
          setCards(true);
          let data = res.data;
          setIndicators({
            confirmed: {
              today: data.contratosConfirmadosHoy,
              month: data.contratosConfirmadosMes,
              stock: data.contratosConfirmadosTotal,
            },
            expired: {
              today: data.contratosVencidosHoy,
              month: data.contratosVencidosMes,
              stock: data.contratosVencidosTotal,
            },
            canceled: {
              today: data.contratosRechazadosHoy,
              month: data.contratosRechazadosMes,
              stock: data.contratosRechazadosTotal,
            },
            pending: {
              today: data.contratosPendientes,
            },
            notrenewed: {
              today: data.contratosConfirmadosNoRenovadosHoy,
              month: data.contratosConfirmadosNoRenovadosMes,
              stock: data.contratosConfirmadosNoRenovadosTotal,
            },
            renewed: {
              today: data.contratosRenovadosHoy,
              month: data.contratosRenovadosMes,
              stock: data.contratosRenovadosTotal,
            },
            pendingrenewal: {
              today: data.contratosPendientesRenovacion,
            },
          });
        })
        .catch((err) => {
          setDataToast({
            active: true,
            message:
              "Ocurrió un error al cargar los indicadores, intente nuevamente.",
            type: "error",
          });
        });
    }
  }

  const getAgreementByIndicator = (
    page,
    indicatorAgreements,
    indicatorDetail
  ) => {
    setIsLoading(true);
    let paginationFilter = {
      page: page,
      pageSize: itemsPerPage,
    };
    api
      .getListAgreementsByIndicators(
        paginationFilter,
        indicatorAgreements,
        indicatorDetail,
        companyFilter ? companyFilter.key : null
      )
      .then((res) => {
        let dataApi = res.data;
        if (
          dataApi &&
          Array.isArray(dataApi.resultado) &&
          dataApi.cantidad > 0
        ) {
          setDataTablePopup(dataApi.resultado);
          let amount = paginationData.amount;
          amount = Math.ceil(dataApi.cantidad / itemsPerPage);
          setPaginationData({
            amount: amount,
            currentPage: page,
          });
          setOpenPopup(true);
          setIsLoading(false);
        } else {
          setDataToast({
            active: true,
            message: "No se encontraron contratos para el indicador.",
            type: "error",
          });
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setDataToast({
          active: true,
          message:
            err.response && Array.isArray(err.response.data.errores)
              ? err.response.data.errores.map((message) => message)
              : "Ocurrió un error al cargar los contratos seleccionados, intente nuevamente.",
          type: "error",
        });
        setIsLoading(false);
      });
  };

  const changePage = (event, value) => {
    paginate(value);
    let currentPage = value;
    let amount = paginationData.amount;
    setPaginationData({
      amount: amount,
      currentPage: currentPage,
    });
  };

  const AgreementsIndicators = ({ Name, Title, Info, IndicatorType }) => {
    let className = "c-indicator-" + Name;
    let loader = <CircularProgress size={10} />;
    let today = loader;
    let month = loader;
    let stock = loader;
    let data = indicators[Name];
    if (data !== undefined) {
      if (data.today !== undefined) today = data.today;
      if (data.month !== undefined) month = data.month;
      if (data.stock !== undefined) stock = data.stock;
    }

    return (
      <>
        <Paper className={"c-indicator " + className}>
          <div className="c-p-10">
            <h5>
              {Title}
              <Tooltip title={Info} placement="top" className="t-tip">
                <InfoIcon />
              </Tooltip>
            </h5>
            <Grid className={className + "-data"} container spacing={1}>
              {Name !== "pending" && Name !== "pendingrenewal" ? (
                <>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    onClick={(e) => {
                      setFilterIndicator({
                        indicatorType: IndicatorType,
                        indicatorDetail: IndicatorDetail.Today,
                      });
                      getAgreementByIndicator(
                        1,
                        IndicatorType,
                        IndicatorDetail.Today
                      );
                    }}
                  >
                    <h3>Hoy</h3>
                    <h4>{today}</h4>
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    onClick={() => {
                      setFilterIndicator({
                        indicatorType: IndicatorType,
                        indicatorDetail: IndicatorDetail.Month,
                      });
                      getAgreementByIndicator(
                        1,
                        IndicatorType,
                        IndicatorDetail.Month
                      );
                    }}
                  >
                    <h3>Mes actual</h3>
                    <h4>{month}</h4>
                  </Grid>
                  <Grid
                    item
                    md={4}
                    xs={12}
                    onClick={() => {
                      setFilterIndicator({
                        indicatorType: IndicatorType,
                        indicatorDetail: IndicatorDetail.Stock,
                      });
                      getAgreementByIndicator(
                        1,
                        IndicatorType,
                        IndicatorDetail.Stock
                      );
                    }}
                  >
                    <h3>Stock</h3>
                    <h4>{stock}</h4>
                  </Grid>
                </>
              ) : (
                <Grid
                  item
                  md={12}
                  xs={12}
                  onClick={() => {
                    setFilterIndicator({
                      indicatorType: IndicatorType,
                      indicatorDetail: IndicatorDetail.Stock,
                    });
                    getAgreementByIndicator(
                      1,
                      IndicatorType,
                      IndicatorDetail.Stock
                    );
                  }}
                >
                  <h3>Actuales</h3>
                  <h4>{today}</h4>
                </Grid>
              )}
            </Grid>
          </div>
        </Paper>
      </>
    );
  };

  const getStatus = (num) => {
    let descriptionByNum = "";
    let className = "c-chip-";

    switch (num) {
      case AgreementStatus.Pending.Id:
        descriptionByNum = AgreementStatus.Pending.Text;
        className += "pending";
        break;
      case AgreementStatus.Confirmed.Id:
        descriptionByNum = AgreementStatus.Confirmed.Text;
        className += "confirmed";
        break;
      case AgreementStatus.Canceled.Id:
        descriptionByNum = AgreementStatus.Canceled.Text;
        className += "canceled";
        break;
      case AgreementStatus.Expired.Id:
        descriptionByNum = AgreementStatus.Expired.Text;
        className += "expired";
        break;
      case AgreementStatus.NotRenewed.Id:
        descriptionByNum = AgreementStatus.NotRenewed.Text;
        className += "notrenewed";
        break;
    }
    return <Chip size="small" className={className} label={descriptionByNum} />;
  };

  const TableRowData = ({ item }) => {
    return (
      <TableRow key={item.contratoId}>
        <TableCell className="c-text-center">{item.contratoId}</TableCell>
        <TableCell className="c-text-center">
          {item.cliente.esEmpresa
            ? item.cliente.razonSocial
            : item.cliente.nombre + " " + item.cliente.apellido}
        </TableCell>
        <TableCell className="c-text-center">
          {item.cliente.numeroDocumento}
        </TableCell>
        <TableCell className="c-text-center">
          {getStatus(item.numeroEstadoPago)}
        </TableCell>
        <TableCell className="c-text-center">{item.compania}</TableCell>
        <TableCell className="c-text-center">{item.producto}</TableCell>
        <TableCell className="c-text-center">
          {item.fechaConfirmacion}
        </TableCell>
        <TableCell className="c-text-center">{item.fechaCaducidad}</TableCell>
      </TableRow>
    );
  };

  return (
    <>
      {isAdmin && (
        <>
          <Paper className="c-grid" elevation={3}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Grid className="c-grid-header" container spacing={1}>
                  <Grid item xs={6}>
                    <h2>FILTROS</h2>
                  </Grid>
                </Grid>
              </Grid>

              <Grid className="c-grid-header-filter c-mt-10" item xs={12}>
                <form onSubmit={search}>
                  <Grid container spacing={1}>
                    <Grid item md={10} xs={12}>
                      <FormControl
                        variant="outlined"
                        fullWidth={true}
                        size="small"
                      >
                        <ReactSelect
                          placeholder="Buscar compañias..."
                          name="company"
                          onChange={(e) => {
                            setCompanyFilter(e);
                          }}
                          options={companiesList}
                          isClearable={true}
                          required
                          value={companyFilter ?? undefined}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <Button
                        className="c-btn-info c-mt-2"
                        variant="contained"
                        fullWidth={true}
                        type="submit"
                        startIcon={<SearchIcon />}
                      >
                        Buscar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </Paper>

          {cards && (
            <>
              <Grid className="c-mt-20">
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Confirmados"
                        Name="confirmed"
                        Info="Contratos pendientes que se fueron confirmando."
                        IndicatorType={IndicatorsType.Confirmed}
                      />
                    </div>
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Pendientes"
                        Name="pending"
                        Info="Contratos pendientes de confirmación."
                        IndicatorType={IndicatorsType.Pending}
                      />
                    </div>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Vencidos"
                        Name="expired"
                        Info="Contratos pendientes que no fueron confirmados en el día."
                        IndicatorType={IndicatorsType.Expired}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Cancelados"
                        Name="canceled"
                        Info="Contratos que fueron dados de baja por algún motivo."
                        IndicatorType={IndicatorsType.Canceled}
                      />
                    </div>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos No Renovados"
                        Name="notrenewed"
                        Info="Contratos que caducaron y tenian marca de No Renovación."
                        IndicatorType={IndicatorsType.NotRenewed}
                      />
                    </div>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Renovados"
                        Name="renewed"
                        Info="Contratos que caducaron y tenian marca de Renovación."
                        IndicatorType={IndicatorsType.Renewed}
                      />
                    </div>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <div className="c-cursor-pointer">
                      <AgreementsIndicators
                        Title="Contratos Pendientes a Renovar"
                        Name="pendingrenewal"
                        Info="Contratos confirmados que caducarán en el rango de 60 días."
                        IndicatorType={IndicatorsType.PendingRenewal}
                      />
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}

          {openPopup && dataTablePopup && dataTablePopup.length > 0 && (
            <Dialog
              open={openPopup}
              onClose={() => setOpenPopup(false)}
              aria-labelledby="form-dialog-title"
              fullWidth={true}
              maxWidth={false}
            >
              <DialogContent>
                <Paper className="c-grid-results" elevation={3}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TableContainer>
                        <Table className="c-table" size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell className="c-text-center">
                                <b>N° DE CONTRATO</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>CLIENTE</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>DOCUMENTO</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>ESTADO</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>COMPAÑÍA</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>PRODUCTO</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>FECHA CONFIRMACIÓN</b>
                              </TableCell>
                              <TableCell className="c-text-center">
                                <b>FECHA CADUCIDAD</b>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {dataTablePopup.map((item) => (
                              <TableRowData
                                item={item}
                                key={item.contratoId}
                              ></TableRowData>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      container
                      direction="column"
                      alignItems="center"
                      justify="center"
                    >
                      <Pagination
                        className="c-pagination"
                        onChange={changePage}
                        page={paginationData.currentPage}
                        count={
                          paginationData.amount > 1 ? paginationData.amount : 0
                        }
                        shape="rounded"
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </DialogContent>

              <DialogActions>
                <Button onClick={() => setOpenPopup(false)} color="primary">
                  Cerrar
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </>
      )}
    </>
  );
}
